/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationsItemsDeleteManyRequestBody = {
  /**
   * Array of item IDs to delete
   */
  itemIds: Array<string>;
};

export type ConversationsItemsDeleteManyRequest = {
  conversationId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody: ConversationsItemsDeleteManyRequestBody;
};

/** @internal */
export const ConversationsItemsDeleteManyRequestBody$inboundSchema: z.ZodType<
  ConversationsItemsDeleteManyRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  item_ids: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    "item_ids": "itemIds",
  });
});
/** @internal */
export type ConversationsItemsDeleteManyRequestBody$Outbound = {
  item_ids: Array<string>;
};

/** @internal */
export const ConversationsItemsDeleteManyRequestBody$outboundSchema: z.ZodType<
  ConversationsItemsDeleteManyRequestBody$Outbound,
  z.ZodTypeDef,
  ConversationsItemsDeleteManyRequestBody
> = z.object({
  itemIds: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    itemIds: "item_ids",
  });
});

export function conversationsItemsDeleteManyRequestBodyToJSON(
  conversationsItemsDeleteManyRequestBody:
    ConversationsItemsDeleteManyRequestBody,
): string {
  return JSON.stringify(
    ConversationsItemsDeleteManyRequestBody$outboundSchema.parse(
      conversationsItemsDeleteManyRequestBody,
    ),
  );
}
export function conversationsItemsDeleteManyRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ConversationsItemsDeleteManyRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ConversationsItemsDeleteManyRequestBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ConversationsItemsDeleteManyRequestBody' from JSON`,
  );
}

/** @internal */
export const ConversationsItemsDeleteManyRequest$inboundSchema: z.ZodType<
  ConversationsItemsDeleteManyRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  conversation_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() =>
    ConversationsItemsDeleteManyRequestBody$inboundSchema
  ),
}).transform((v) => {
  return remap$(v, {
    "conversation_id": "conversationId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type ConversationsItemsDeleteManyRequest$Outbound = {
  conversation_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody: ConversationsItemsDeleteManyRequestBody$Outbound;
};

/** @internal */
export const ConversationsItemsDeleteManyRequest$outboundSchema: z.ZodType<
  ConversationsItemsDeleteManyRequest$Outbound,
  z.ZodTypeDef,
  ConversationsItemsDeleteManyRequest
> = z.object({
  conversationId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() =>
    ConversationsItemsDeleteManyRequestBody$outboundSchema
  ),
}).transform((v) => {
  return remap$(v, {
    conversationId: "conversation_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function conversationsItemsDeleteManyRequestToJSON(
  conversationsItemsDeleteManyRequest: ConversationsItemsDeleteManyRequest,
): string {
  return JSON.stringify(
    ConversationsItemsDeleteManyRequest$outboundSchema.parse(
      conversationsItemsDeleteManyRequest,
    ),
  );
}
export function conversationsItemsDeleteManyRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConversationsItemsDeleteManyRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ConversationsItemsDeleteManyRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationsItemsDeleteManyRequest' from JSON`,
  );
}
